// extracted by mini-css-extract-plugin
module.exports = {"EmployeeActions":"EmployeeActions__EmployeeActions___38cT8","ActionButton":"EmployeeActions__ActionButton___2R0PT","ButtonOverride":"EmployeeActions__ButtonOverride___ERrEo"};